import { createAsyncThunk } from '@reduxjs/toolkit';
import shopModel from 'store/models/shop';
import { TShopItem } from '../types/shopSchema';

//GET
export const fetchShopItems = createAsyncThunk(
  'shop/fetchShopItems',
  async (_, { rejectWithValue }) => {
    try {
      const response: {
        data: {
          data: TShopItem[];
        };
      } = await shopModel.getShopItems();
      // console.log(response);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

//GET
export const fetchBuyShopItem = createAsyncThunk(
  'shop/fetchBuyShopItem',
  async (itemId: string, { rejectWithValue, dispatch }) => {
    try {
      const response: {
        data: {
          data: TShopItem[];
        };
      } = await shopModel.postBuyItem(itemId);
      dispatch(fetchShopItems());
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
